// Angular
import { ChangeDetectorRef, Component, OnInit, Output, EventEmitter, Input, LOCALE_ID } from '@angular/core'
import { MatSnackBar } from '@angular/material'
import { Router,ActivatedRoute } from '@angular/router'
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'
// Layout
import { OffcanvasOptions } from '../../../../core/_base/layout'
import { AppService, StateService } from '../../../../services'

import { Panier } from '../../../../Interfaces/Panier'

import {Observable,	BehaviorSubject, Subject} from "rxjs";
import { DateAdapter , MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

const KEY = 'quick-panel'

@Component({
	selector: 'atyl-quick-panel',
	templateUrl: './quick-panel.component.html',
	styleUrls: ['./quick-panel.component.scss'],
	providers: [
		AppService,
		
		{ provide: LOCALE_ID, useValue: 'fr-FR' },
		{ provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
		},
		{ provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },
		{
			provide: MAT_DATE_FORMATS, useValue: {
			parse: {
				dateInput: 'L',
			},
			display: {
				dateInput: 'L',
				monthYearLabel: 'MMM YYYY',
				dateA11yLabel: 'L',
				monthYearA11yLabel: 'MMM YYYY',
			},
			}
		}
	]
})
@Stringable({
	path: 'views/partials/layout/quick-panel',
	key: KEY,
})
export class QuickPanelComponent implements OnInit {

	@StringableValues(KEY)
	strings: any
	notifications:any;
	user: any;
	panier:Panier;
	get:boolean;
	ia:any;

	toLoadConsultion:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
	loadpanier:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
	toLoadIA:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
	
    isNotifHistorique:boolean=false;
    
    notifOnCourseCount:number=0;
    notifHistoriqueCount:number=0;
    
	// Public properties
	offcanvasOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-quick-panel',
		closeBy: 'kt_quick_panel_close_btn',
		toggleBy: 'kt_quick_panel_toggler_btn',
	};

	constructor(

		private appService: AppService,
		private stateService: StateService,
		private changeDetectorRef: ChangeDetectorRef,
		private router: Router,
		private snackBar: MatSnackBar,
		private activatedRoute: ActivatedRoute,
	) {

	}
	ngOnInit() {
		this.notifications = this.stateService.notifications.getValue()
		this.setNotificationCount();
		this.stateService._notifications.subscribe((notifs: any) => {
			this.notifications = notifs
			this.setNotificationCount();
			this.changeDetectorRef.detectChanges()
		})
		this.stateService.user.subscribe((user) => {
			if (user) {
				this.user = user

				console.log("user dossier",this.user)

			}
		})
		this.stateService.panier.subscribe((panier: Panier) => {
			this.panier = panier
			
			this.changeDetectorRef.detectChanges()
		})
		
		this.stateService.ia.subscribe((ia) => {
					if (ia) {
						this.ia=ia;

					}
		})
	}

    setNotificationCount() {
		if (this.notifications.notifications) {
			this.notifHistoriqueCount=0;
			this.notifOnCourseCount=0;
			
			for(let i=0;i<this.notifications.notifications.length;i++) {
				let notif:any=this.notifications.notifications[i]
			    
				 if (notif.instruction!=undefined  
						&& notif.instruction.etape!=undefined) {
						if (notif.instruction.etape.historique)
							this.notifHistoriqueCount++;
						else
							this.notifOnCourseCount++;
							
					}
				
			}
			this.changeDetectorRef.detectChanges()
		}
	}

	setNotification(event: MouseEvent, notif: any, actions: any) {

		event.stopPropagation()
		event.preventDefault()
		this.appService.setNotification(notif.id, actions).subscribe((res) => {
			this.appService.getAllNotifications().subscribe((notifs) => {
				this.stateService.updateNotifications(notifs.result)
			})
		})
	}

	routerLink(notif: any) {
		console.log("natification link",notif);
		
		  this.appService.notifSeen(notif.id).subscribe((res) => {
               
               if (notif.instruction!=undefined  
					&& notif.instruction.demande!=undefined
					&& notif.instruction.demande.dossier!=undefined
					&& notif.instruction.demande.dossier.tiers!=undefined
				){
                    this.router.navigate(['/home/dossier/' + notif.instruction.demande.dossier.tiers.type+'/' + notif.instruction.demande.dossier.ID], {
                        relativeTo: this.activatedRoute,
                        queryParams: {
                            instruction: notif.instruction.ID, 
                            historique: notif.instruction.etape.historique
                        }
                    })
                }
                
                this.appService.getAllNotifications().subscribe((notifs) => {
						this.stateService.updateNotifications(notifs.result)
						this.setNotificationCount();
			})
      
       });
		
		
		
		
		
}
	
	loadConsultations() {
		this.toLoadConsultion.next(true);
	}
	
	
	loadPanier() {
		if(this.get == undefined){
			this.get = this.stateService.PanierGet.getValue();
			this.stateService.PanierGet.next(true);
		}
	}
	
	loadIA() {
			this.toLoadIA.next(true);
	  }
}
